var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"method-options-card-header"},[_c('div',{staticClass:"method-options-card-header__icon",style:(_vm.logoStyles(_vm.method))}),(!_vm.isOnlyOneService)?_c('div',{staticClass:"method-options-card-header__description"},[_c('h5',[_vm._v(_vm._s(_vm.$t('chose_preferred_currency')))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }